export default __webpack_public_path__ + "static/media/7.d5964356.jpg";